import Box from "@mui/material/Box";
import { styled, alpha } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  drawer: {
    backgroundColor: theme.palette.background.main,
  },

  drawerPaper: {
    backgroundColor: theme.palette.background.main,
    color: theme.palette.text.main,
  },

  toolbar: {
    padding: theme.spacing(5, 5),
    height: theme.spacing(3),
    // border:`${theme.spacing(0.1)} solid ${alpha(theme.palette.primary.main,.1)}`
  },
}));
